module.exports = __webpack_public_path__ + "static/rc20-0f04ab94c9d77a3c39a815cfa9328612.jpg";